import React from 'react';
import './Error404Page.scss';

const Error404Page: React.FC = () => {
  return (
    <section id="error-404-page">
      <h2>404 Error</h2>
      <p>Page Not Found</p>
    </section>
  );
};

export default Error404Page;
